<app-page-wrapper
  [useFooter]="true"
  [useHeader]="true"
  [useBackBtn]="true"
  [title]="title"
  [subtitle]="subtitle"
>
  <ion-content>
    <div class="step-online-credit" *ngIf="loaded$ | async">
      <form class="new-online-credit-form" [formGroup]="formGroup">
        <div class="new-online-credit-form__label">Для подачи заявки необходимо Ваше согласие</div>

        <app-form-checkbox
                [option]="agreeCheckRating.title"
                [textData]="agreeCheckRating.text"
                formControlName="agreementBki"
        ></app-form-checkbox>

        <app-form-checkbox
                [option]="agreeUsePersonalInfo.title"
                [textData]="agreementsPfrText$ | async"
                formControlName="agreementPfr"
        ></app-form-checkbox>
      </form>
    </div>
  </ion-content>

  <ng-container footer *ngIf="loaded$ | async">
    <ion-button expand="block" class="button block primary" ripple-effect
                [disabled]="formGroup.invalid" (click)="confirm()">Подтвердить
    </ion-button>
    <ion-button expand="block"
                class="button primary-light"
                ripple-effect
                (click)="abort()"
    >
      Отмена
    </ion-button>
  </ng-container>

</app-page-wrapper>



